<div class="inner-page-header">
  <h3>{{ mainTitle }} خدمة</h3>
</div>
<div class="new-service-wrapper">
  <form [formGroup]="addServiceFormGroup">
    <div class="main-card">
      <div class="service-tools">
        <app-switch-input
          [label]="'حالة الخدمة'"
          [labelEn]="'is_active'"
          [labelDesc]="'(مفعل/غير مفعل)'"
          [index]="770"
          [value]="isActive"
          (valueChanged)="isActiveValueChanged($event)"
        >
        </app-switch-input>
        @if(isActiveExsep !== null){
        <!-- <app-switch-input
          [label]="' تفعيل الخدمة لسوبرا'"
          [labelEn]="'is_active_for_exsep'"
          [labelDesc]="'(مفعل/غير مفعل)'"
          [index]="771"
          [value]="isActiveExsep"
          (valueChanged)="isActiveValueChanged($event)"
        >
        </app-switch-input> -->
        }
        <div class="header-actions d-flex">
          @if (!addStatus) {
          <button class="btn btn-green" (click)="goToSettings()">
            <img
              class="setting-img"
              src="assets/images/svg/setting-def.svg"
              alt="settings"
            />
            إعدادت الخدمة
          </button>
          <div class="services-managment">
            <button
              class="btn btn-add"
              mat-button
              [matMenuTriggerFor]="orderMenu"
            >
              إدارة الخدمات
              <img src="assets/images/svg/dropDownArrow.svg" alt="" />
            </button>
            <mat-menu #orderMenu="matMenu">
              <a (click)="updateCategories()" mat-menu-item>
                تعديل التصنيفات
              </a>
              <a (click)="redistrebuteRatios()" mat-menu-item>
                اعادة توزيع النسب
              </a>
              <a (click)="openServiceCredentials()" mat-menu-item>
                اشترطات تقديم الخدمة
              </a>
            </mat-menu>
          </div>
          }
        </div>
      </div>
      <div class="service-data">
        <div class="form-group">
          <label for="" class="form-label">اسم الخدمة</label>
          <input
            type="text"
            formControlName="name"
            class="form-control"
            placeholder="يرجى كتابة اسم الخدمة"
            [ngClass]="{
              'invalid-field':
                addServiceFormGroup.controls['name'].errors && alertmsg
            }"
          />
        </div>
        <div class="form-group">
          <label for="" class="form-label"> النص التوضيحى</label>
          <input
            type="text"
            formControlName="explantion_txt"
            class="form-control"
            placeholder="يرجى كتابة نص توضيحى"
            [ngClass]="{
              'invalid-field':
                addServiceFormGroup.controls['explantion_txt'].errors &&
                alertmsg
            }"
          />
        </div>
        <div class="form-group">
          <label for="" class="form-label">حالة إظهار البنود</label>
          <ng-select
            bindLabel="name"
            class="single-select"
            placeholder=""
            appendTo="body"
            formControlName="show_terms"
            [searchable]="true"
            [clearable]="true"
          >
            @for (choice of choicesList; track choice) {
            <ng-option [value]="choice.id">
              {{ choice.name }}
            </ng-option>
            }
          </ng-select>
        </div>
        <div class="form-group">
          <label for="" class="form-label">اسماء التقييم</label>
          <a class="add-item" (click)="addCompletionStatus()"
            ><img alt="" src="/assets/images/svg/add-icon-blue.svg" /> إضافة نوع
            تقييم
          </a>
          <ng-select
            bindLabel="name"
            class="single-select"
            placeholder=""
            appendTo="body"
            formControlName="completion_status"
            [searchable]="true"
            [clearable]="true"
            (scrollToEnd)="onScrollCustomChoicesPagination()"
          >
            @for (choice of statusCustomChoices; track choice) {
            <ng-option [value]="choice.id">
              {{ choice.name }}
            </ng-option>
            }
          </ng-select>
        </div>
        <div class="form-group">
          <label for="" class="form-label"> بيانات العقار </label>
          <app-select
            [optionItems]="buildingDetails"
            [placeholder]="'يرجى تحديد بيانات العقار'"
            [id]="'buildingDetails'"
            [initValues]="initBuildingDetails"
            [maxLength]="2"
            (selectedOptions)="setBuildingDetails($event)"
          >
          </app-select>
        </div>
        <div class="form-group">
          <label for="" class="form-label">زمن إتاحة الطلب للخبراء في ال Pool بعد</label>
          <div class="input-with-suffix">
            <input
              type="number"
              formControlName="order_pool_delay_minutes"
              class="form-control"
              placeholder="حدد المدة قبل إتاحة الطلب للخبراء"
              [ngClass]="{
                'invalid-field':
                  addServiceFormGroup.controls['order_pool_delay_minutes'].errors && alertmsg
              }"
            />
            <span class="input-suffix">دقيقة</span>
          </div>
        </div>

        <div class="form-group">
          <label for="" class="form-label">طريقة عرض الملاحظات في التقرير</label>            
          <ng-select
            bindLabel="name"
            class="single-select"
            placeholder=""
            appendTo="body"
            formControlName="default_notes_display"
            [searchable]="true"
            [clearable]="true"
          >
            @for (choice of notesDisplayChoices; track choice) {
            <ng-option [value]="choice.id">
              {{ choice.name }}
            </ng-option>
            }
          </ng-select>
        </div>
      </div>

      <div class="single-action">
        <app-action-button (submitAction)="save($event)"></app-action-button>
      </div>

      @if (alertmsg) {
      <div class="alert-box">
        <img
          src="assets/images/svg/error-icon.svg"
          class="close-alert"
          (click)="closeError()"
          alt=""
        />
        <p class="alert-msg">{{ message }}</p>
      </div>
      }
    </div>
    <div formArrayName="categories" class="panel-wrapper">
      @for ( category of categories().controls; track category; let
      categoryIndex = $index) {
      <mat-accordion>
        <mat-expansion-panel
          (opened)="(true)"
          (closed)="(false)"
          [formGroupName]="categoryIndex"
          class="company-accordion"
        >
          <mat-expansion-panel-header class="header-parent">
            <mat-panel-title>
              <div>
                {{ category.value.name }}
                <span>({{ category.value.ratio }}%)</span>
              </div>
              <img
                alt=""
                src="assets/images/svg/wrench.svg"
                (click)="updateCategories(); $event.stopPropagation()"
                alt=""
              />
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="panel-body company-panel">
            @for (item of terms(categoryIndex).controls; track i; let i =
            $index) {
            <div class="new-row" formArrayName="terms">
              <ng-container [formGroupName]="i">
                <app-switch-input
                  [label]="'أبرز الملاحظات'"
                  [labelEn]="'is_decision_driver'"
                  [index]="getTermUniqueIndex(categoryIndex, i)"
                  [labelDesc]="'(مفعل/غير مفعل)'"
                  [value]="item['controls']['is_decision_driver'].value"
                  (valueChanged)="isActiveDecisionValueChanged($event, categoryIndex , i)"
                >
                </app-switch-input>
                <div class="term-wrapper">
                  <div class="item-wrapper">
                    <label for="" class="form-label">البند</label>
                    <input
                      type="text"
                      formControlName="name"
                      class="form-control"
                      placeholder=" يرجى كتابة البند"
                      [ngClass]="{
                        'invalid-field':
                          item['controls']['name'].errors && alertmsg
                      }"
                    />
                  </div>
                  <div class="item-wrapper">
                    <label for="" class="form-label">المرجعية</label>
                    <input
                      type="text"
                      formControlName="description"
                      class="form-control"
                      placeholder="يرجى كتابة المرجعية "
                      [ngClass]="{
                        'invalid-field':
                          item['controls']['description'].errors && alertmsg
                      }"
                    />
                  </div>
                  <div>
                    <label for="" class="form-label">نسبة التأثير</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        aria-label=""
                        formControlName="ratio"
                        placeholder="نسبة التصنيف"
                        [ngClass]="{
                          'invalid-field':
                            item['controls']['ratio'].errors && alertmsg
                        }"
                      />
                      <div class="input-group-append">
                        <span class="input-group-text">%</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label for="" class="form-label">تكلفة الإصلاح</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        aria-label=""
                        formControlName="repairing_cost"
                        placeholder=" تكلفه الإصلاح"
                        [ngClass]="{
                          'invalid-field':
                            item['controls']['repairing_cost'].errors && alertmsg
                        }"
                      />
                    </div>
                  </div>
                  <div class="action-wrapper">
                    @if (i == 0) {
                    <button
                      class="btn btn-add"
                      (click)="addItem(categoryIndex)"
                    >
                      <img alt="" src="assets/images/svg/add-service.svg" />
                    </button>
                    } @else {
                    <button
                      class="btn btn-add"
                      (click)="deleteItem(categoryIndex, i)"
                    >
                      <img alt="" src="assets/images/svg/DELETE1.svg" />
                    </button>
                    }
                    <button
                      class="btn btn-add"
                      (click)="changeCategory(item['controls'], categoryIndex)"
                    >
                      <img alt="" src="assets/images/svg/edit-icon.svg" />
                    </button>
                  </div>
                </div>

                <div class="indexation-wrapper" formGroupName="indexations">
                  <div class="add-indexation">
                    <ng-container>
                      <div class="item-wrapper">
                        <label for="" class="form-label">التوصيف للفاحص</label>
                        <input
                          type="text"
                          formControlName="name"
                          class="form-control"
                          placeholder="ادخل التوصيف هنا"
                        />
                      </div>
                      <div class="item-wrapper">
                        <label for="" class="form-label">
                          التوصيف للعميل
                        </label>
                        <input
                          type="text"
                          formControlName="description"
                          class="form-control"
                          placeholder="ادخل التوصيف هنا"
                        />
                      </div>
                      <div class="w-10">
                        <label for="" class="form-label">سعر الوحدة </label>
                        <div class="input-group">
                          <input
                            type="number"
                            class="form-control"
                            formControlName="unit_cost"
                            aria-label=""
                            placeholder="سعر الوحدة"
                          />
                        </div>
                      </div>
                      <div class="w-10">
                        <label for="" class="form-label">وحدة القياس</label>
                        <ng-select
                          bindLabel="name"
                          (scrollToEnd)="onScrollPagination()"
                          #selectMeasurement
                          formControlName="unit_of_measurement"
                          placeholder="وحدة القياس"
                          appendTo="body"
                          [searchable]="true"
                          [virtualScroll]="true"
                          [clearable]="true"
                        >
                          @for (unit of
                          getFilteredUnits(serviceDetails.units_of_measurement);
                          track unit) {
                          <ng-option [value]="unit.id">
                            {{ unit.name }}
                          </ng-option>
                          }
                        </ng-select>
                      </div>
                      <app-action-button
                        [label]="'إضافة'"
                        [disabled]="
                          item.get('indexations')?.invalid ||
                          !item.get('indexations').get('name').touched
                        "
                        (submitAction)="
                          addIndexationItem(
                            categoryIndex,
                            i,
                            item.get('id')?.value,
                            $event
                          )
                        "
                      ></app-action-button>
                    </ng-container>
                  </div>
                  @if(serviceDetails?.categories[categoryIndex]?.terms[i]?.indexations?.length
                  > 0){
                  <div class="indextion-table">
                    <table class="table table-striped">
                      <thead>
                        <tr>
                          <th>نشط</th>
                          <th>التوصيف للفاحص</th>
                          <th>التوصيف للعميل</th>
                          <th>سعر الوحدة</th>
                          <th>وحدة القياس</th>
                          <th>تفاعل</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (indexation of
                        serviceDetails.categories[categoryIndex].terms[i].indexations;
                        track indexation; let indexationIndex = $index ) {
                        <tr>
                          <td>
                            <label class="checkbox-container">
                              <input
                                type="checkbox"
                                value="{{ indexation.is_default }}"
                                [checked]="indexation.is_default"
                                [id]="'index' + '_' + indexationIndex"
                                disabled
                              />
                              <span class="checkmark"></span>
                            </label>
                          </td>
                          <td>{{ indexation.name }}</td>
                          <td>{{ indexation.description }}</td>
                          <td>{{ indexation.unit_cost }}</td>
                          <td>
                            {{ getUnitName(indexation.unit_of_measurement) }}
                          </td>
                          <td class="action-wrapper">
                            <button
                              class="btn btn-add"
                              (click)="
                                editIndexation(
                                  indexation,
                                  item.get('id').value,
                                  getFilteredUnits(
                                    serviceDetails.units_of_measurement
                                  ),
                                  categoryIndex,
                                  i,
                                  indexationIndex
                                )
                              "
                            >
                              <img
                                alt=""
                                src="assets/images/svg/edit-icon.svg"
                              />
                            </button>
                          </td>
                        </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  }
                </div>
              </ng-container>
            </div>
            } @if (errorMsg && selectedAccordion == categoryIndex) {
            <div class="alert-box">
              <img
                src="assets/images/svg/error-icon.svg"
                class="close-alert"
                (click)="closeError()"
                alt=""
              />
              <p class="alert-msg">{{ message }}</p>
            </div>
            }
            <app-action-button
              class="btn btn-green"
              [disabled]="!areTermsValid(categoryIndex)"
              (submitAction)="
                saveCategory(categoryIndex); selectedAccordion = categoryIndex
              "
            ></app-action-button>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
      }
    </div>
  </form>
</div>
